/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ElementsUserMiniReference
 */
export interface ElementsUserMiniReference {
    /**
     * 
     * @type {number}
     * @memberof ElementsUserMiniReference
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserMiniReference
     */
    readonly avatar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserMiniReference
     */
    readonly displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserMiniReference
     */
    readonly email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserMiniReference
     */
    readonly fullName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserMiniReference
     */
    readonly isExternal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserMiniReference
     */
    readonly isCloud?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserMiniReference
     */
    readonly username?: string;
}

export function ElementsUserMiniReferenceFromJSON(json: any): ElementsUserMiniReference {
    return ElementsUserMiniReferenceFromJSONTyped(json, false);
}

export function ElementsUserMiniReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementsUserMiniReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'avatar': !exists(json, 'avatar') ? undefined : json['avatar'],
        'displayName': !exists(json, 'display_name') ? undefined : json['display_name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'fullName': !exists(json, 'full_name') ? undefined : json['full_name'],
        'isExternal': !exists(json, 'is_external') ? undefined : json['is_external'],
        'isCloud': !exists(json, 'is_cloud') ? undefined : json['is_cloud'],
        'username': !exists(json, 'username') ? undefined : json['username'],
    };
}

export function ElementsUserMiniReferenceToJSON(value?: ElementsUserMiniReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


